<div class="card container">
	<form (submit)="submit()" class="card-body">
		<div class="form-floating mb-3">
			<input class="form-control" name="newName" [(ngModel)]="newName" id="newName" />
			<label for="newName">Nowy typ dokumentu</label>
		</div>
		<div class="d-grid">
			<button class="btn btn-primary">Zapisz</button>
		</div>
	</form>
</div>
